<template>
  <v-row>
    <v-col cols="12" md="3">
      <v-text-field
        type="text"
        dense
        small-chips
        hide-details
        v-model="jumlah"
      ></v-text-field>
    </v-col>
    <v-col cols="12" md="2">
      <v-autocomplete
        dense
        hide-details
        :items="units"
        v-model="biaya.satuan"
      ></v-autocomplete>
    </v-col>
    <v-icon>mdi-close</v-icon>
    <v-col cols="12" md="3">
      <v-text-field
        type="text"
        dense
        small-chips
        hide-details
        v-model="harga"
      ></v-text-field>
    </v-col>
    <v-icon>mdi-equal</v-icon>
    <v-col cols="12" md="3">
      <v-text-field
        type="text"
        dense
        small-chips
        hide-details
        disabled
        v-model="total"
      ></v-text-field>
    </v-col>
    <v-icon class="cursor-pointer delete" @click="deleteRow(i)">
      mdi-close
    </v-icon>
  </v-row>
</template>

<script>
export default {
  name: "PelunasanBL",
  props: {
    biaya: Object,
    i: Number
  },
  data() {
    return {
      units: [
        {
          text: "M3",
          value: "M3"
        },
        {
          text: "Ton",
          value: "Ton"
        },
        {
          text: "Unit",
          value: "Unit"
        },
        {
          text: "Container",
          value: "Container"
        }
      ]
    };
  },
  computed: {
    total: {
      get() {
        return this.formatCurrency(this.biaya.jumlah * this.biaya.harga);
      },
      set(val) {
        return (this.biaya.total = this.biaya.jumlah * this.biaya.harga);
      }
    },
    jumlah: {
      get() {
        return this.formatCurrency(this.biaya.jumlah);
      },
      set(val) {
        return (this.biaya.jumlah = this.convertToAngka(val));
      }
    },
    harga: {
      get() {
        return this.formatCurrency(this.biaya.harga);
      },
      set(val) {
        return (this.biaya.harga = this.convertToAngka(val));
      }
    }
  },
  methods: {
    deleteRow(i) {
      this.$emit("delete", i);
    },
    formatCurrency(num) {
      return new Intl.NumberFormat("id-ID").format(num);
    },
    convertToAngka(nilai) {
      if (nilai == "0" || nilai == "" || nilai == null) return 0;

      let desimal = nilai.split(",")[1];
      let angka = nilai
        .split(",")[0]
        .split(".")
        .join("");
      return parseFloat(`${angka}.${desimal}`);
    }
  }
};
</script>

<style scoped>
.delete {
  color: red;
}
</style>
